import React,{useState,useEffect} from "react";
import { toast } from "react-toastify";
import api from "../../../api/api"
import { useForm } from "react-hook-form";


const BookMarkCreate = () => {
  const { register, handleSubmit } = useForm();

  const handleSub = (data)=> {
    console.log(data)
    api.post('/info/bookmarks/',data)
    .then(response=> {
      toast.success("Bookmarks created")
    }).catch(error=> {
      toast.error("Something went wrong")
    })
  }
  
  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Bookmark
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <form onSubmit={handleSubmit(handleSub)}>
      <div className="mt-5 px-3 md:!px-10">
        <div className="">
          <div className="grid md:grid-cols-2">
            {/* site name */}
            <div className="border-primary-blue flex items-center gap-2 border-2 p-2">
              <label htmlFor="" className="text-primary-red">
                Site Name
              </label>
              <input
                type="text"
                {...register("name", { required: false })}

                // name=""
                className="flex-grow py-2 px-2 outline-none"
                id="nepali-datepicker"
                placeholder="Select Nepali Date"
              />
            </div>
            {/* Action */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:!border-t-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Action:
              </label>
              <label className="text-primary-blue" htmlFor="">
                Show
              </label>
              <input
                type="radio"
                // name="action"
                value={true}
                {...register("is_active", { required: false })}
                
                className="py-2 px-2 outline-none"
              />
              <label className="text-primary-blue" htmlFor="">
                Hide
              </label>
              <input
                type="radio"
                name="action"
                value= {false}
                {...register("is_active", { required: false })}
                className="py-2 px-2 outline-none"
              />
            </div>
            {/* site details */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Site Details:
              </label>
              <input
                {...register("details", { required: false })}

                type="text"
                // name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Details"
              />
            </div>
            {/* Link */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
              <label htmlFor="" className="text-primary-red">
                Link:
              </label>
              <input
                {...register("link", { required: false })}

                type="text"
                // name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Link"
              />
            </div>
          </div>
        </div>
        {/* buttons */}
        <button 
          className="bg-primary-green ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
        >
          Save
        </button>
        {/* <a
          href=""
          className="bg-primary-blue ml-10 mt-5 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
        >
          Submit
        </a> */}
      </div>
      </form>
      {/* end table */}
    </div>
  );
};

export default BookMarkCreate;
